var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalletCase = function SvgWalletCase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E1CE06",
    d: "M0 .625C0 .28.28 0 .625 0h6.25C7.22 0 7.5.28 7.5.625v6.596l5.184-5.164a.625.625 0 0 1 .883.001l4.42 4.42a.625.625 0 0 1-.002.884L12.828 12.5h6.547c.345 0 .625.28.625.625v6.25c0 .345-.28.625-.625.625H3.75a3.74 3.74 0 0 1-2.652-1.098A3.74 3.74 0 0 1 0 16.305m7.5-.262 9.16-9.124-3.536-3.536L7.5 8.986zm-1.875.207a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m13.125 2.5v-5h-7.177l-5.02 5zM0 .625v15.618zM0 16.243v.007z"
  })));
};
export default SvgWalletCase;